export default __webpack_public_path__ + "static/media/Celebration-dedication-icon.0fcee712.png";